<template>
  <Loading v-if="$auth0.isLoading.value" title="Authenticating..." />
  <template v-else>
    <div v-if="showWallpaper" class="wallpaper" />
    <router-view />
  </template>
</template>

<script setup>
import { computed } from "vue";
import { useAuth0 } from "@auth0/auth0-vue";
import { useRoute } from "vue-router";

const $auth0 = useAuth0();
const route = useRoute();

const isAuthenticated = $auth0.isAuthenticated;

const showWallpaper = computed(() => {
  return isAuthenticated.value || route.path === "/menu-login";
});
</script>

<style lang="css">
</style>
